export default __webpack_public_path__ + "static/media/closer-tyrfing.148c069e.mp3";